// SIMPLICITÉ – Benefits Bar (ULTRA LIGHT)
(function () {
  if (window.__SIMP_BENEFITS__) return;
  window.__SIMP_BENEFITS__ = true;

  const FREE_SHIPPING_THRESHOLD = 199;
  let lastTotal = null;
  let timer = null;

  function qs(s){ return document.querySelector(s); }
  function hasBar(){ return qs("[data-benefits-progress]") && qs("[data-benefits-text]"); }

  function formatMoney(cents){
    return (cents / 100).toLocaleString("pt-BR", { style:"currency", currency:"BRL" });
  }

  function updateUI(totalCents){
    const bar = qs("[data-benefits-progress]");
    const text = qs("[data-benefits-text]");
    if(!bar || !text) return;

    const total = totalCents / 100;
    const pct = Math.min((total / FREE_SHIPPING_THRESHOLD) * 100, 100);
    bar.style.width = pct + "%";

    if(total >= FREE_SHIPPING_THRESHOLD){
      text.textContent = "🎉 Você desbloqueou o frete grátis!";
    } else {
      const remaining = FREE_SHIPPING_THRESHOLD - total;
      text.innerHTML = `Faltam <strong>${formatMoney(Math.round(remaining*100))}</strong> para ganhar frete grátis`;
    }
  }

  async function fetchCart(){
    if(!hasBar()) return;
    try{
      const res = await fetch("/cart.js", { credentials:"same-origin" });
      const cart = await res.json();
      const total = cart.total_price || 0;
      if(total === lastTotal) return;
      lastTotal = total;
      updateUI(total);
    } catch(e){}
  }

  function schedule(ms=300){
    clearTimeout(timer);
    timer = setTimeout(fetchCart, ms);
  }

  document.addEventListener("DOMContentLoaded", ()=> schedule(100));
  document.addEventListener("click", (e)=>{
    if(e.target.closest('button[name="add"]')) schedule(500);
    if(e.target.closest('a[href="/cart"], summary[aria-controls*="cart"]')) schedule(300);
  }, {passive:true});
})();